import React from 'react';


const PrivacyPolicy = () => {
    return (
        <>
            <div className='bg-bgprimary w-full min-h-[200px]' >   </div>
            <div className="privacy-policy">
                <h1>Privacy Policy</h1>
                <p>At West Breeze, we are committed to protecting your privacy. This policy explains how we handle your personal information.</p>
                <h2>1. Information Collection</h2>
                <p>We collect information that you provide directly to us, such as when you sign up or make a purchase.</p>
                <p>Additionally, we may automatically collect certain information when you use our website, including your IP address, browser type, and usage data through cookies and other tracking technologies.</p>
                <h2>2. Use of Information</h2>
                <p>Your information is used to provide, maintain, and improve our services and communicate with you.</p>
                <p>This may include sending promotional emails about new products, special offers, or other information we think you may find interesting using the email address which you have provided.</p>
                <h2>3. Information Sharing</h2>
                <p>We do not share your personal information with third parties except as required by law or to provide our services.</p>
                <p>However, we may share your information with trusted third-party service providers who assist us in operating our website, conducting our business, or serving you, so long as those parties agree to keep this information confidential.</p>
                <h2>4. Security</h2>
                <p>We take reasonable measures to protect your personal information from unauthorized access or disclosure.</p>
                <p>However, please note that no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
            </div>
        </>

    );
};

export default PrivacyPolicy;